export enum AdminSideMenuItemUrl {
  Users = "/admin/users",
  Programs = "/admin/programs",
  Questionnaires = "/admin/questionnaires",
  Reports = "/admin/reports",
}
